/* ============================================================
   Marjo et son petit robot pref 🤖
   Traduction Zepto, page produit

   Ce fichier :
   - traduit les labels, valeurs et tooltips Zepto sur les pages produit EN
   - applique quelques exceptions selon les balises produit
   - laisse le popup Linea / Linea Halo au Custom JS de Zepto
   ============================================================ */

(function () {
  function getZeptoRoot() {
    return document.querySelector(".product-personalizer, .pplr-wrapper, [id^='pplr-']");
  }

  function isEnglishPage() {
    const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    return htmlLang.startsWith("en");
  }

  function normalizeText(text) {
    return String(text || "")
      .replace(/\s+/g, " ")
      .replace(/\(\s+/g, "(")
      .replace(/\s+\)/g, ")")
      .replace(/[’]/g, "'")
      .trim();
  }

  function getProductTags() {
    if (!Array.isArray(window.productTags)) return [];
    return window.productTags.map(function (tag) {
      return String(tag || "").trim().toLowerCase();
    });
  }

  function hasProductTag(tagName) {
    return getProductTags().includes(String(tagName || "").trim().toLowerCase());
  }

  /* ===== Traductions globales ===== */
  const globalLabels = {
    "Entrez votre numéro d'adresse civique": "Enter your house numbers",
    "Couleur": "Color",
    "Couleur de boîte aux lettres": "Mailbox color",
    "Couleur des numéros": "Number color",
    "Sens": "Orientation",
    "Orientation": "Orientation",
    "Type d'installation": "Installation type",
    "Trousse d'installation gratuite": "Free installation kit",
    "Format de la plaque": "Address plaque size",
    "Hauteur des chiffres": "Number height",
    "Nombre de chiffres dans votre adresse": "Number of digits in your address",
    "Nombre de chiffres": "Number of digits",
    "Option de verrouillage": "Mailbox locking option"
  };

  const globalValues = {
    "Noir": "Black",
    "Blanc": "White",
    "Aluminium brossé": "Brushed Aluminum",
    "Horizontal": "Horizontal",
    "Vertical": "Vertical",
    "Oui": "Yes",
    "Non": "No",
    "Formats réguliers": "Regular sizes",
    "Autres formats": "Other sizes",
    "Aimanté (pour les revêtements d'acier)": "Magnetic (for steel siding)",
    "Collé": "3M adhesive (no drilling required)",

    /* Variantes Zepto */
    "Standard (trousse gratuite)": "Standard (free accessories kit)",
    "Standard ( trousse gratuite)": "Standard (free accessories kit)",
    "Standard (trousse gratuite )": "Standard (free accessories kit)"
  };

  const globalTooltips = {
    "Une trousse d'installation qui contient un niveau, du silicone, une mèche tout usage et un crayon est offerte gratuitement pour l'installation standard.":
      "A free installation kit including a level, silicone, a multi-purpose drill bit, and a pencil is included with standard installation.",

    "Comprend un niveau, du silicone, une mèche tout usage et un crayon pour une installation facile.":
      "Includes a level, silicone, a multi-purpose drill bit, and a pencil for an easy installation.",

    "Si vous désirez ajouter votre adresse sur votre boîte aux lettres, inscrivez la ici , sinon laisser l'espace vide.":
      "If you'd like to add your address to your mailbox, enter it here. Otherwise, leave the field blank."
  };

  function translateLabelElements(zeptoRoot) {
    const labels = zeptoRoot.querySelectorAll(".pplrlabel, .lbl");

    labels.forEach(function (labelEl) {
      Array.from(labelEl.childNodes).forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;

        const originalText = normalizeText(node.nodeValue);
        if (!originalText) return;

        const translatedText = globalLabels[originalText];
        if (!translatedText || translatedText === originalText) return;

        node.nodeValue = node.nodeValue.replace(originalText, translatedText);
      });
    });
  }

  function translateValueElements(zeptoRoot) {
    const valueElements = zeptoRoot.querySelectorAll(".pplr-drop-item");

    valueElements.forEach(function (valueEl) {
      const originalText = normalizeText(valueEl.textContent);
      if (!originalText) return;

      const translatedText = globalValues[originalText];
      if (!translatedText || translatedText === originalText) return;

      valueEl.textContent = translatedText;
    });
  }

  function translateVisibleOptionText(zeptoRoot) {
    const elements = zeptoRoot.querySelectorAll(
      ".pplr_option_text_span, .pplr_option_text, .pplr-swatch-label"
    );

    elements.forEach(function (el) {
      const originalText = normalizeText(el.textContent);
      if (!originalText) return;

      const translatedText = globalValues[originalText];
      if (!translatedText || translatedText === originalText) return;

      el.textContent = translatedText;
    });
  }

  function translateTooltipElements(zeptoRoot) {
    const tooltips = zeptoRoot.querySelectorAll(".ptooltiptext");

    tooltips.forEach(function (tooltipEl) {
      let textNode = null;

      Array.from(tooltipEl.childNodes).forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE && normalizeText(node.nodeValue) !== "") {
          textNode = node;
        }
      });

      if (!textNode) return;

      const originalText = normalizeText(textNode.nodeValue);
      if (!originalText) return;

      const translatedText = globalTooltips[originalText];
      if (!translatedText || translatedText === originalText) return;

      textNode.nodeValue = translatedText;
    });
  }

  /* ===== Verrouillage boîte aux lettres (Urbaine + Casa) ===== */

  function translateLockOption(zeptoRoot) {
    const activeTexts = zeptoRoot.querySelectorAll(".pplr_option_text_span");

    activeTexts.forEach(function (el) {
      const originalText = normalizeText(el.textContent);
      if (!originalText) return;

      if (originalText === "- Sans serrure") {
        el.textContent = " - Without lock";
      }

      if (originalText === "- Avec serrure") {
        el.textContent = " - With lock";
      }
    });
  }
  /* ===== Exceptions produit ===== */

  function applyUrbaineExceptions(zeptoRoot) {
    if (!hasProductTag("zepto_urbaine")) return;

    const urbaineLabels = {
      "Si vous désirez ajouter votre adresse sur votre boîte aux lettres,":
        "If you'd like to add your address to your mailbox,",
      "veuillez compléter les informations suivantes :":
        "please complete the following:"
    };

    const urbaineValues = {
      "Canyon lustré": "Glossy Canyon",
      "Olive lustré": "Glossy Olive",
      "Vert ancien lustré": "Glossy Yesterday Green",
      "Barista lustré": "Glossy Barista",
      "Argile mat": "Matte Clay",
      "1 ou 2": "1 or 2",
      "3 et plus": "3 and more"
    };

    const labels = zeptoRoot.querySelectorAll(".pplrlabel, .lbl");

    labels.forEach(function (labelEl) {
      Array.from(labelEl.childNodes).forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;

        const originalText = normalizeText(node.nodeValue);
        if (!originalText) return;

        const translatedText = urbaineLabels[originalText];
        if (!translatedText || translatedText === originalText) return;

        node.nodeValue = node.nodeValue.replace(originalText, translatedText);
      });
    });

    const valueElements = zeptoRoot.querySelectorAll(".pplr-drop-item");

    valueElements.forEach(function (valueEl) {
      const originalText = normalizeText(valueEl.textContent);
      if (!originalText) return;

      const translatedText = urbaineValues[originalText];
      if (!translatedText || translatedText === originalText) return;

      valueEl.textContent = translatedText;
    });
  }

  function applyAutocollantExceptions(zeptoRoot) {
    if (!hasProductTag("zepto_autocollant")) return;

    const autocollantLabels = {
      "Sélectionner le nombre de bacs": "Select the number of bins"
    };

    const autocollantValues = {
      "1 bac": "1 bin",
      "2 bacs": "2 bins",
      "3 bacs": "3 bins"
    };

    const labels = zeptoRoot.querySelectorAll(".pplrlabel, .lbl");

    labels.forEach(function (labelEl) {
      Array.from(labelEl.childNodes).forEach(function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;

        const originalText = normalizeText(node.nodeValue);
        if (!originalText) return;

        const translatedText = autocollantLabels[originalText];
        if (!translatedText || translatedText === originalText) return;

        node.nodeValue = node.nodeValue.replace(originalText, translatedText);
      });
    });

    const valueElements = zeptoRoot.querySelectorAll(".pplr-drop-item");

    valueElements.forEach(function (valueEl) {
      const originalText = normalizeText(valueEl.textContent);
      if (!originalText) return;

      const translatedText = autocollantValues[originalText];
      if (!translatedText || translatedText === originalText) return;

      valueEl.textContent = translatedText;
    });

    const activeTexts = zeptoRoot.querySelectorAll(".pplr_option_text_span");

    activeTexts.forEach(function (el) {
      const originalText = normalizeText(el.textContent);
      if (!originalText) return;

      if (originalText === "- 1 bac") {
        el.textContent = " - 1 bin";
      }

      if (originalText === "- 2 bacs") {
        el.textContent = " - 2 bins";
      }

      if (originalText === "- 3 bacs") {
        el.textContent = " - 3 bins";
      }
    });
  }

  function translateModerneTooltips(zeptoRoot) {
    if (!hasProductTag("zepto_moderne")) return;

    const tooltips = zeptoRoot.querySelectorAll(".ptooltiptext");

    tooltips.forEach(function (el) {
      const text = el.innerHTML;
      if (!text) return;

      if (text.includes("1-2 chiffres = 11")) {
        el.innerHTML =
          'Not sure which length to choose?<br>Here are our recommendations:<br>1–2 digits = 11"<br>3 digits = 16"<br>4–5 digits = 23"';
      } else if (text.includes("Formats suggérés selon le nombre de chiffres")) {
        el.innerHTML =
          'Not sure which length to choose?<br>Here are our recommendations based on your address:<br>1–2 digits = 9"<br>3 digits = 11.5"<br>4 digits = 15"<br>5 digits = 19"';
      } else if (text.includes("Quelle hauteur choisir")) {
        el.innerHTML =
          'Not sure which height to choose?<br>Here are our recommendations:<br>1 digit = 9"<br>2 digits = 11.5"<br>3 digits = 15"<br>4 digits = 19"<br>5 digits are not available in vertical format';
      } else if (
        text.includes("Une trousse d’installation est fournie") ||
        text.includes("Une trousse d'installation est fournie")
      ) {
        el.innerHTML =
          "The Standard option includes a free installation kit (level, silicone, drill bit and pencil) for a quick and easy setup.";
      }
    });
  }

  /* ===== Linea hors popup ===== */

  function translateLineaLaunchButton() {
    if (!isEnglishPage()) return;

    const buttons = document.querySelectorAll(".pplr-c-button");

    buttons.forEach(function (button) {
      const text = normalizeText(button.textContent).toLowerCase();

      if (text === "personnalisez votre adresse") {
        button.textContent = "CUSTOMIZE YOUR ADDRESS";
      }
    });
  }

  function runTranslation() {
    if (!isEnglishPage()) return;

    translateLineaLaunchButton();

    const zeptoRoot = getZeptoRoot();
    if (!zeptoRoot) return;

    translateLabelElements(zeptoRoot);
    translateValueElements(zeptoRoot);
    translateVisibleOptionText(zeptoRoot);
    translateTooltipElements(zeptoRoot);
    translateLockOption(zeptoRoot);

    applyUrbaineExceptions(zeptoRoot);
    applyAutocollantExceptions(zeptoRoot);
    translateModerneTooltips(zeptoRoot);
  }

  function initTranslation() {
    runTranslation();

    const observer = new MutationObserver(function () {
      runTranslation();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    setTimeout(runTranslation, 300);
    setTimeout(runTranslation, 800);
    setTimeout(runTranslation, 1500);
    setTimeout(runTranslation, 2500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTranslation);
  } else {
    initTranslation();
  }

  window.addEventListener("load", runTranslation);
})();